/* eslint-disable max-len, react/jsx-indent, react/no-danger */
import React from 'react';
import PageIcons from './Icons';

import styles from './policy.module.scss';

function AboutUs() {
  return (
    <>
      <PageIcons />
      <div className={styles.container}>
        <div className={styles.aboutUsWrapper}>
          <div className={styles.heading_main}>
            About Us
          </div>
          <div className={styles.midContainer}>
            <div className={styles.each_Data}>
              <div className={styles.title_name}>
                <h2>Overview</h2>
              </div>
              <div className={styles.describe}>
                We StudyIQ Education is Pvt Ltd Education Company Dedicated to provide online education to students who are willing to or already participated in indian government jobs exam either in english or hindi medium through the pre-recorded videos, so that the student can learn and achieve his/her dream government job by study smart and by comfort of home. We are a team who is dedicated to our work and motive to provide best and time efficient study tutorials/video classes without use of internet connection from any part state district of india.
              </div>
            </div>
            <div className={styles.each_Data}>
              <div className={styles.title_name}>
                <h2>Vision and Mission</h2>
              </div>
              <div className={styles.describe}>
                Our mission is to provide every student a complete education and study material for the exam he/she appearing or willing to participate.
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default AboutUs;
